// Shared client for every form on the site. One function, reused by
// all 5 forms — each just passes its own formType/entity/payload.
// Talks to the Tyk-fronted contact service (Express + MongoDB).

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export async function submitForm(formType, entity, payload, spamCheck = {}) {
  const { hp = "", startedAt = null } = spamCheck;
  try {
    const res = await fetch(`${API_BASE}/api/v1/submit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ formType, entity, payload, hp, startedAt }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.ok) {
      const message = data?.error ? JSON.stringify(data.error) : `Request failed (${res.status})`;
      return { ok: false, error: message };
    }
    return { ok: true, id: data.id };
  } catch (err) {
    return { ok: false, error: "Network error — please try again." };
  }
}
